import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getCouponById, updateCoupon } from "../../actions/couponAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import CouponForm from "./CouponForm";

// yyyy-mm-dd, the format a native date input expects
const toDateInput = (value) =>
  value ? new Date(value).toISOString().split("T")[0] : "";

const EditCoupon = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [coupon, setCoupon] = useState(null);

  useEffect(() => {
    const getCoupon = async () => {
      setLoader(true);
      let res = await getCouponById(id);
      if (res?.data?.data) {
        const data = res.data.data;
        setCoupon({
          code: data.code || "",
          title: data.title || "",
          discountType: data.discountType || "fixed",
          discountValue: data.discountValue ?? "",
          maxDiscountAmount: data.maxDiscountAmount ?? 0,
          minOrderAmount: data.minOrderAmount ?? 0,
          firstTimeOnly: !!data.firstTimeOnly,
          usageLimit: data.usageLimit ?? 0,
          usageLimitPerUser: data.usageLimitPerUser ?? 1,
          startDate: toDateInput(data.startDate),
          endDate: toDateInput(data.endDate),
          status: !!data.status,
        });
      }
      setLoader(false);
    };
    getCoupon();
  }, [id]);

  const handleSubmit = async (values) => {
    setLoader(true);
    let res = await updateCoupon(id, values);
    if (res?.data?.success) {
      toast.success(res.data.message);
      navigate("/coupon");
    }
    setLoader(false);
  };

  return (
    <>
      {loader || !coupon ? (
        <FullPageLoader />
      ) : (
        <CouponForm
          heading="Edit Coupon"
          initialValues={coupon}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default EditCoupon;
